/**
 * @module
 *
 * @import {Controller, Scope} from "@acng/frontend-stargazer"
 */
import {create, DIV} from '@acng/frontend-bounty/dom/element.js';
import {append} from '@acng/frontend-bounty/dom/move.js';
import {noop} from '@acng/frontend-bounty/std/value.js';
import {popup} from '@acng/frontend-discovery';
import {guard, IS_TEMPLATE} from '@acng/frontend-rubicon';
import {DESTROY, Engine, UPGRADE} from '@acng/frontend-stargazer';
import {ClickController} from './click';

/**
 * @implements {Controller}
 */
class DropdownController {
  /**
   * @param {(close: () => void) => Scope} scopeFn
   */
  constructor(scopeFn) {
    this.scopeFn = scopeFn;
  }

  /**
   * @param {Element} template
   *
   * @returns {Controller}
   */
  [UPGRADE](template) {
    ASSERT: guard(template, IS_TEMPLATE);
    let destroyed = false;
    const engine = new Engine(template);
    const div = create(DIV);
    const close = () => popup(template).close(div);

    return {
      [UPGRADE]: async () => {
        await engine.lookup();

        if (destroyed) {
          return;
        }

        const fragment = engine.link(this.scopeFn(close), div, noop);
        append(div, fragment);
        const closed = popup(template).showModal(div);
        engine.connect();
        await closed;

        engine.disconnect();
      },
      [DESTROY]: () => {
        destroyed = true;
        close();
      },
    };
  }

  /*
  get click() {
    return new ClickController(...);
  }
  */

  /**
   * @param {string[]} path
   */
  async open(path) {
    const engine = await Engine.root.render(...path);
    const div = create(DIV);
    const close = () => popup().close(div);
    const fragment = engine.link(this.scopeFn(close), div, noop);
    append(div, fragment);
    // disable auto close
    const closed = popup().add(div, 1e10);
    engine.connect();
    await closed;
    engine.disconnect();
  }
}

export {DropdownController};
